import { fetchApi } from '../../../lib/fetchApi';
import { UpdateStatusAlert, SurveyAlertDto } from '../types';

export type updateAlertStateDTO = {
    idEnquesta: number;
    idState: number;
    orderId: number;
};

export const changeDestinationAlert = async (destination: UpdateStatusAlert): Promise<void> => {
    await fetchApi.put(`/alert/order`, destination);
};

export const changeIAValuesAlert = async (getAlertSurveyById: number, values: SurveyAlertDto): Promise<void> => {
    await fetchApi.put(`/alert/survey/${getAlertSurveyById}`, values);
};

